"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tone = require("tone");

var _tone2 = _interopRequireDefault(_tone);

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Bandpassed noise organ
 * @module lib/bandpass.js;
 */

var root = 440;

var oscillators = {};
var output = void 0;
var lastPlayed = void 0;
var noise = void 0;

function load(out) {
  output = out;
}
function isPlaying(interval) {
  var rounded = (0, _util.roundInterval)(interval);
  var osc = oscillators[rounded];
  return osc && osc.playing;
}
function play(interval) {
  if (!output) {
    return;
  }
  if (!noise) {
    noise = new _tone2.default.Noise().start();
  }
  var rounded = (0, _util.roundInterval)(interval);
  var osc = oscillators[rounded] = oscillators[rounded] || {};
  if (!osc.el) {
    osc.interval = interval;
    osc.el = new _tone2.default.Filter(interval * root, "bandpass");
    osc.el.Q.value = 100;
  }
  noise.connect(osc.el);
  osc.el.connect(output);
  osc.playing = true;
  lastPlayed = osc;
  return osc;
}

function pause(interval) {
  var rounded = (0, _util.roundInterval)(interval);
  if (!oscillators[rounded]) return;
  var osc = oscillators[rounded] = oscillators[rounded] || {};
  osc.el.disconnect(output);
  noise.disconnect(osc.el);
  osc.playing = false;
  return osc;
}
function toggle(interval) {
  var rounded = (0, _util.roundInterval)(interval);
  var osc = oscillators[rounded] = oscillators[rounded] || {};
  if (osc && osc.playing) {
    pause(interval);
  } else {
    play(interval);
  }
}

function setRoot(newRoot) {
  root = newRoot;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.values(oscillators)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var osc = _step.value;

      osc.el.frequency.value = osc.interval * newRoot;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}
function stop() {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = Object.values(oscillators)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var osc = _step2.value;

      if (!osc.playing) {
        continue;
      }
      osc.el.disconnect(output);
      noise.disconnect(osc.el);
      osc.playing = false;
      delete osc.el;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  oscillators = {};
}
function getPlaying() {
  return Object.values(oscillators).filter(function (osc) {
    return osc.playing;
  }).map(function (osc) {
    return osc.interval;
  });
}

exports.default = {
  load: load,
  isPlaying: isPlaying,
  getPlaying: getPlaying,
  play: play,
  pause: pause,
  toggle: toggle,
  stop: stop,
  setRoot: setRoot
};


//////////////////
// WEBPACK FOOTER
// ./client/lib/bandpass.js
// module id = 260
// module chunks = 0